import {MutationTree} from "vuex";
import IUser from "@/modules/UserManager/ts/IUser";
import moment from 'moment';
import IDataVariable from "@/modules/DataVariables/ts/IDataVariable";
import IAnnouncement from "@/ts/IAnnouncement";
import IACL from "@/ts/IACL";
import Echo from "laravel-echo";

export const mutations: MutationTree<any> = {

    setUser(state: any, payload: IUser) {
        state.user = Object.assign({}, state.user, payload);
        state.userExpire = moment().add(240, 'minutes');
        if (state.UserManager) {
            const index = state.UserManager.users.findIndex((u: IUser) => u.id === payload.id);
            if (index !== -1) {
                state.UserManager.users.splice(index, 1, payload);
            }
        }
    },

    setSession(state: any, payload: Object) {
        state.session = payload;
        state.sessionExpire = moment().add(240, 'minutes');
    },

    setEcho(state: any, payload: Echo) {
        state.echo = payload;
    },

    setSettings(state: any, payload: Object) {
        state.settings = payload;
        state.settingsExpire = moment().add(240, 'minutes');
    },

    setTimezones(state: any, timezones: Array<string>) {
        state.timezones = timezones;
    },

    setTimezonesLoading(state: any, payload: boolean) {
        state.timezonesLoading = payload;
    },

    setDataVariablesLoading(state: any, payload: boolean) {
        state.dataVariablesLoading = payload;
    },

    bustDataVariableCache(state: any) {
        state.dataVariablesExpire = null;
    },

    setDataVariable(state: any, dataVariable: IDataVariable) {
        let index = state.dataVariables.findIndex((variable: IDataVariable) => variable.id === dataVariable.id);

        if (index === -1) throw new Error("Data variable not found!");

        // Remove old data variable (due Vue reactivity with arrays)
        state.dataVariables.splice(index, 1);

        // Add new variable
        state.dataVariables.push(dataVariable);
    },

    setDataVariables(state: any, dataVariables: Array<IDataVariable>) {
        state.dataVariables = dataVariables;
        state.dataVariablesExpire = moment().add(15, 'minutes');
    },

    setDataVariableOptions(state: any, payload: any) {

        let dataVariableId = payload.id;

        let dataVar = state.dataVariables.find((variable: IDataVariable) => {
            return variable.id == dataVariableId;
        });

        dataVar.options = payload;
    },

    addDataVariable: function (state: any, payload: IDataVariable) {

        // Typescript bug it things value is being mutated
        if (payload.type !== 'radio' && payload.type as any !== 'checkbox') {
            delete payload.options;
        }

        state.dataVariables.push(payload);
    },

    updateDataVariable(state: any, payload: IDataVariable) {

        // Typescript bug it things value is being mutated
        if (payload.type !== 'radio' && payload.type as any !== 'checkbox') {
            delete payload.options;
        }

        let index = state.dataVariables.findIndex((node: IDataVariable) => {
            return node.id === payload.id;
        });

        state.dataVariables.splice(index, 1, payload);
    },

    deleteDataVariable(state: any, dataVariableId: number) {
        let index = state.dataVariables.findIndex((dataVariable: IDataVariable) => {
            return dataVariable.id === dataVariableId;
        });
        state.dataVariables.splice(index, 1);
    },

    assignGroupToVariables(state: any, payload: any) {

        payload.dataVariables.forEach((variable: IDataVariable) => {

            let found = state.dataVariables.find((dataVariable: IDataVariable) => {
                return dataVariable.id === variable.id;
            });

            if (!found) {
                throw new Error("Data variable not found " + variable.id);
            }

            found.group = Object.assign({}, payload.group);
        });
    },

    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setMessages(state: any, payload: Array<any>) {
        state.announcements = payload.filter((val) => val.type === 'App\\Notifications\\Announcement');
        state.notifications = payload.filter((val) => val.type !== 'App\\Notifications\\Announcement');
        state.expires = moment().add(15, 'minutes');
    },

    addAnnouncement(state: any, announcement: IAnnouncement) {
        if (!announcement.created_at) announcement.created_at = moment.utc().format('YYYY-MM-DD HH:mm:ss');
        state.announcements.push(announcement);
    },

    addNotification(state: any, notification: IAnnouncement) {
        if (!notification.created_at) notification.created_at = moment.utc().format('YYYY-MM-DD HH:mm:ss');
        state.notifications.unshift(notification);
    },

    bustMessagesCache(state: any) {
        state.expires = null;
    },

    bustAnnouncementsCache(state: any) {
        state.expiresAnnouncements = null;
    },

    setAllAnnouncements(state: any, payload: Array<any>) {
        state.allAnnouncements = payload;
        state.expiresAnnouncements = moment().add(15, 'minutes');
    },

    removeMessages(state: any, ids: Array<string>) {
        state.announcements = state.announcements.filter((announcement: IAnnouncement) => {
            return !ids.includes(announcement.id);
        });

        state.notifications = state.notifications.filter((notification: IAnnouncement) => {
            return !ids.includes(notification.id);
        });
    },

    saveAcl(state: any, acl: IACL) {
        state.user.permissions = acl.permissions;
        state.user.roles = acl.roles;
    },

    setActiveEngaged(state: any, payload: Array<any>) {
        state.activeEngaged = payload;
        state.activeEngagedExpires = moment().add(240, 'minutes');
    },

    setActiveEngagedLoading(state: any, payload: boolean) {
        state.activeEngagedLoading = payload;
    },

    setAgeGender(state: any, payload: Array<any>) {
        state.ageGender = payload;
        state.ageGenderExpires = moment().add(240, 'minutes');
    },

    setAgeGenderLoading(state: any, payload: boolean) {
        state.ageGenderLoading = payload;
    },
};